import $http from './http'
import config from './config'
export default {
    name: 'traffic',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getOrderList(data) {
        return $http.post(this.getUrl('/trafficorder/list'), data);
    }, 
    OrderUnLock(id) {
        return $http.get(this.getUrl(`/trafficorder/OrderUnLock?UniqueID=${id}`));
    },
    OrderLock(id) {
        return $http.get(this.getUrl(`/trafficorder/OrderLock?UniqueID=${id}`));
    },
    
    OrderDetails(UniqueID) {
        return $http.get(this.getUrl(`/trafficorder/OrderDetails?UniqueID=${UniqueID}`));
    },
    OrderSubmit(UniqueID) {
        return $http.get(this.getUrl(`/trafficorder/OrderSubmit/${UniqueID}`));
    },
    OrderCannot(id) {
        return $http.get(this.getUrl(`/trafficorder/OrderCannot?UniqueID=${id}`));
    },
    OrderDrawer(id) {
        return $http.get(this.getUrl(`/trafficorder/OrderDrawer?UniqueID=${id}`));
    },
    OrderReject(id) {
        return $http.get(this.getUrl(`/trafficorder/OrderReject?UniqueID=${id}`));
    },
    OrderResolve(data) {
        return $http.post(this.getUrl(`/trafficorder/OrderResolve`), data);
    },
    OrderCancel(id) {
        return $http.get(this.getUrl(`/trafficorder/OrderCancel?UniqueID=${id}`), {
            failTips: false
        });
    },
    ClientOrderResolve(data) {
        return $http.post(this.getUrl('/trafficorder/ClientOrderResolve'), data);
    },
    ConfirmOrderPrice(data) {
        return $http.post(this.getUrl(`/trafficorder/ConfirmOrderPrice`), data)
    },
    UpdateOrderStatus(id) {
        return $http.get(this.getUrl(`/trafficorder/UpdateOrderStatus?UniqueID=${id}`));
    },
    UpdateOrderPrice(data) {
        return $http.post(this.getUrl('/trafficorder/UpdateOrderPrice'), data);
    },
    AmendStatusBack(id) {
        return $http.get(this.getUrl(`/trafficorder/AmendStatusBack?UniqueID=${id}`));
    },

    CreateTrade(data) {
        return $http.post(this.getUrl(`/trafficorder/CreateTrade`), data);
    },

    ConfirmClientAmendPrice(data){
        return $http.post(this.getUrl('/trafficorder/ConfirmClientAmendPrice'),data)
    },

    ConfirmSupplyAmendPrice(data){
        return $http.post(this.getUrl('/trafficorder/ConfirmSupplyAmendPrice'),data)
    },

    getOrderList(data) {
        return $http.post(this.getUrl('/trafficorder/List'), data);
    },
    
    CreateRefundRequest(data) {
        return $http.post(this.getUrl('/trafficorder/CreateRefundRequest'), data);
    },
    RefundJudge(UniqueID) {
        return $http.get(this.getUrl(`/trafficorder/RefundJudge?UniqueID=${UniqueID}`));
    },

    UpdateOrder(data) {
        return $http.post(this.getUrl('/trafficorder/UpdateOrder'), data)
    },
    SearchOrders(id) {
        return $http.get(this.getUrl(`/trafficorder/SearchOrders?UniqueID=${id}`));
    },
    CreateOrder(data) {
        return $http.post(this.getUrl('/trafficorder/CreateOrder'), data);
    },
    traffictest(data){
        return $http.post(this.getUrl('/Callback/Notify/Yuexing'),data)
    }
}



// WEBPACK FOOTER //
// ./src/apis/trafficApi.js